import { container } from './container'
import { plansStore } from '../store/plansStore'
import { orderStore } from '../store/orderStore'
import { menuStore } from '../store/menuStore' 
import { deliveryStore } from '../store/deliveryStore' 
import { User } from '../core/User'

/**
 * A set of usefull calls and utils to perform all various data-entry
 */
export class Repository {

  /**
   * Retrieve the current menu
   *
   * @return Promise
   */
  getCurrentMenu() {
    return menuStore.loadCurrentMenu().then(response => {
      return menuStore.state.menu;
    })
  }

  /**
   * Retrieve plan by people and meals
   *
   * @param int people
   * @param int meals
   *
   * @return Promise
   */
  getPlanByPeopleAndMeals(people, meals) {
    return plansStore.loadPlans().then(response => {
      return plansStore.getPlan(people, meals);
    });
  }

  /**
   * Create a new guest
   *
   * @return Promise
   */
  createGuestOrIgnore() {

    if (container.get('user')) {
      return Promise.resolve();
    }

    return this.createGuest()
  }


  /**
   * Create a new guest
   *
   * @return Promise
   */
  createGuest() {

    return container.get('services.oauth').createGuest()
  }

  /**
   * Create a new guest with empty order
   *
   * @return Promise
   */
	createGuestWithEmtpyOrder () {
    var menu;
    var plan;

    return this.createGuestOrIgnore().then(r => {
      return this.getCurrentMenu()
    }).then(r => {
      menu = r
    }).then(r => {
      return this.getPlanByPeopleAndMeals(2, 0);
    }).then(r => {
      plan = r
    }).then(response => {

      orderStore.state.order = null

      orderStore.updateOrderParam({ param: 'plan_id', value: plan.id})

      if (menu.id) {
        orderStore.updateOrderParam({ param: 'week_plan_id', value: menu.id})
      }

      var params = orderStore.orderParams

      return orderStore.updateOrder()
    }).then(response => {

      return container.get('services.oauth').authenticate()
    }).then(response => {

      container.set('user', new User(response.body.data.resource))
      window.user = container.get('user')

      
      container.get('vue').updateUser(container.get('user'))
    })
	}


  /**
   * Create a new order with current user
   *
   * @return Promise
   */
  retrieveOrCreateOrder () {
    var user = window.user;

    if (!user || !user.subscription) {
      return this.createGuestWithEmtpyOrder();
    } else if (user.order) {
      orderStore.saveOrderToStoreFromEntity(user.order);
      return Promise.resolve(1);
      //return orderStore.retrieveOrder();
    } else {
      return this.createOrderFromSubscription();
    }
  }

  createOrderFromSubscription() {

    var user = container.get('user');
    var menu;
    
    return this.getCurrentMenu().then(r => {
      menu = r
    }).then(response => {
      
      orderStore.state.order = null

      // orderStore.updateOrderParam({ param: 'plan_id', value: user.subscription.plan_id})

      if (menu.id) {
        orderStore.updateOrderParam({ param: 'week_plan_id', value: menu.id})
      }

      var params = orderStore.orderParams

      return orderStore.updateOrder()
    })
  }

  /**
   * Find current order
   *
   * @return Object
   */
  getCurrentOrder () {
    return orderStore.state.order;
  }

  /**
   * Find delivery of current order
   *
   * @return Object
   */
  getCurrentOrderDelivery () {
    return this.getCurrentOrder()
      ? deliveryStore.state.deliveries['order'].find(r => r && r.attributes.target_id == this.getCurrentOrder().id)
      : null;
  }

  /**
   * Find time range of current order
   *
   * @return Object
   */
  getCurrentDeliveryTimeRange () {
    return this.getCurrentOrderDelivery() 
      ? deliveryStore.state.timeRanges.delivery.find(r => r && r.attributes.target_id == this.getCurrentOrderDelivery().id)
      : null;
  }
}